import type { StateCreator } from 'zustand';
import { firmsApi, type Firm, type FirmInput } from '../services/firmsApi';

export interface FirmsSlice {
  firms: Firm[];
  firmsLoading: boolean;
  firmsError: string | null;

  fetchFirms: () => Promise<void>;
  createFirm: (data: FirmInput) => Promise<Firm>;
  updateFirm: (id: number, data: FirmInput) => Promise<void>;
  deleteFirm: (id: number) => Promise<void>;
}

export const createFirmsSlice: StateCreator<FirmsSlice, [], [], FirmsSlice> = (set, get) => ({
  firms: [],
  firmsLoading: false,
  firmsError: null,

  fetchFirms: async () => {
    set({ firmsLoading: true, firmsError: null });
    try {
      const firms = await firmsApi.list();
      set({ firms });
    } catch (e) {
      set({ firmsError: (e as Error).message });
    } finally {
      set({ firmsLoading: false });
    }
  },

  createFirm: async (data) => {
    const created = await firmsApi.create(data);
    await get().fetchFirms();
    return created;
  },

  updateFirm: async (id, data) => {
    await firmsApi.update(id, data);
    await get().fetchFirms();
  },

  deleteFirm: async (id) => {
    await firmsApi.remove(id);
    await get().fetchFirms();
  },
});
